import React from 'react'
import { AccordionContainer } from '../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../common/components/form/input/containers/input.container';



export default function AddWebsiteComponent ({handleInnerFormChange, selectedWebsites}: any) {

  return (
    <>
      <AccordionContainer
    child={
      <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
           <InputContainer
              label="Template Name"
              name="WebsiteName"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'WebsiteName',

                )
              }}
              type="text"
              value={selectedWebsites?.WebsiteName}
          />
           <InputContainer
              label="TemplateVersionId"
              name="WebsiteVersionId"
              onValueChange={(event: any) => {
                handleInnerFormChange(
                  event.target.value,
                  'WebsiteVersionId',

                )
              }}
              type="number"
              value={selectedWebsites?.WebsiteVersionId}
          />
        <InputContainer

label="Remarks"
name="Remarks"
onValueChange={(event: any) => {
  handleInnerFormChange(
    event.target.value,
     'Remarks',

       )
     }}
 type="text"
 value={selectedWebsites?.Remarks}
/>
     </div>
  }
    expandedPanel="userInfo"
    headerTitle="Basic Info"
/>

        </>
  )
}